module.exports = __webpack_public_path__ + "static/media/team-member-06.c3edc6aa.png";